import request from '@/utils/request'
import qs from 'qs'
const proxyUrl = process.env.Communityapi;
//作品详情
export const topicDetail = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    url: proxyUrl + '/circle/topicDetail',
    //data:data,
    data: qs.stringify(data),
  })
};

//根据作者的id获取关注的圈子
export const selectCircleByAuthorId = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    url: proxyUrl + '/circle/selectCircleByAuthorId',
    //data:data,
    data: qs.stringify(data),

  })

};

//根据当前作品标签查询相关作品
export const TopicByTags = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'POST',
    url: proxyUrl + '/circle/selectTopicByTags',
    data: data,
    data: qs.stringify(data),

  })

};

//根据作品回复数量查询热门推荐作品
export const HotTopics = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'POST',
    url: proxyUrl + '/circle/selectHotTopic',
    //data:data,
    data: qs.stringify(data),

  })

};

//级别是签约摄影师以上的点赞展示
export const zaUserLevel = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'POST',
    url: proxyUrl + '/circle/selectUserLevel',
    //data:data,
    data: qs.stringify(data)

  })

};


// WEBPACK FOOTER //
// ./src/utils/api/findDetail.js